<template>
  <v-container width="100%" style="background: #f5f5f5">
    <div id="header" class="mt-3 px-3">
      <h2>{{ $t('Informações do equipamento') }}</h2>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#e8e8e8"
              dark
              depressed
              @click="generatePDF(currentEquipment)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon small color="#0F3565"> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Imprimir') }}</span>
        </v-tooltip>
      </div>
    </div>

    <v-divider class="my-3"></v-divider>

    <v-row
      class="ma-0 px-5"
      v-if="currentEquipment.alienated"
      style="color: #df4759"
    >
      <v-col class="py-0" cols="12">
        <h3>{{ $t('Equipamento Alienado') }}</h3>
      </v-col>
      <v-col class="pb-0" cols="12" sm="4" md="4" lg="4">
        <strong>Data:</strong>
        {{ formatDate(currentEquipment.alienationDate) }}
      </v-col>
      <v-col class="pb-0" cols="12" sm="8" md="8" lg="8">
        <strong>Motivo:</strong>
        {{ currentEquipment.alienationMotive }}
      </v-col>
    </v-row>

    <v-divider v-if="currentEquipment.alienated" class="my-3"></v-divider>

    <v-row dense class="ma-0 px-5">
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <span>
          <strong>{{ $t('MTBF Equipamento') }}:</strong>
          {{ `${mtbf} ${$t('dias')}` }}
        </span>
      </v-col>
      <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
        <span>
          <strong>{{ $t('Data de cadastro') }}:</strong>
          {{ formatDate(currentEquipment.create) }}
        </span>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row dense class="ma-0 px-5 py-0">
      <v-col cols="12">
        <h3>{{ $t('Dados gerais') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Identificação') }}:</strong>
          {{ currentEquipment.identification }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Instituição') }}:</strong>
          {{
            currentEquipment.institution
              ? currentEquipment.institution.name
              : $t('Sem registros')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Unidade') }}:</strong>
          {{
            currentEquipment.unidade
              ? currentEquipment.unidade.name
              : $t('Sem registro')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Equip. Padrão') }}:</strong>
          {{
            currentEquipment.standardEquipment
              ? currentEquipment.standardEquipment.name
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Equipamento') }}:</strong>
          {{
            currentEquipment.name != '' ? currentEquipment.name : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Setor') }}:</strong>
          {{
            currentEquipment.department
              ? currentEquipment.department.name
              : 'Sem registro'
          }}
        </p>
      </v-col>

      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Cód Patrimônio') }}:</strong>
          {{
            currentEquipment.propertyCode != ''
              ? currentEquipment.propertyCode
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Fabricante') }}:</strong>
          {{
            currentEquipment.manufacturer != ''
              ? currentEquipment.manufacturer
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Localização') }}:</strong>
          {{
            currentEquipment.location != ''
              ? currentEquipment.location
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Modelo') }}:</strong>
          {{
            currentEquipment.model != ''
              ? currentEquipment.model
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Nº Série') }}:</strong>
          {{
            currentEquipment.serialNumber != ''
              ? currentEquipment.serialNumber
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Nº Anvisa') }}:</strong>
          {{
            currentEquipment.numberAnvisa != ''
              ? currentEquipment.numberAnvisa
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
        <p class="mb-0">
          <strong class="field">{{ $t('Tensão') }}:</strong>
          {{
            currentEquipment.voltage != -1
              ? voltages[currentEquipment.voltage]
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
        <p class="mb-0">
          <strong class="field">{{ $t('Potência') }}:</strong>
          {{
            currentEquipment.candlePower != ''
              ? `${currentEquipment.candlePower} W`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p class="mb-0">
          <strong class="field">{{ $t('Contrato') }}:</strong>
          {{
            currentEquipment.contract != null
              ? currentEquipment.contract.name
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Valor contrato') }}:</strong>
          {{
            currentEquipment.contractValue &&
            currentEquipment.contractValue != 0
              ? `${currentEquipment.contractValue.toInstLocale()}`
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0 px-5" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Criticidade') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p class="mb-0">
          <strong class="field">{{ $t('Função') }}:</strong>
          {{
            currentEquipment.standardEquipment
              ? functionsEquipment[
                  currentEquipment.standardEquipment.functionEquipment
                ]
              : $t('Sem registros')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p class="mb-0">
          <strong class="field">{{ $t('Risco') }}:</strong>
          {{
            currentEquipment.standardEquipment
              ? equipmentRisks[currentEquipment.standardEquipment.equipmentRisk]
              : $t('Sem registros')
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="1" md="1" lg="1">
        <p class="mb-0">
          <strong class="field">{{ $t('Grau') }}:</strong>
          {{
            currentEquipment.degreeImportance != ''
              ? currentEquipment.degreeImportance
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="1" md="1" lg="1">
        <p class="mb-0">
          <strong class="field">{{ $t('Valor') }}:</strong>
          {{
            currentEquipment.criticality != ''
              ? currentEquipment.criticality
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="2" md="2" lg="2">
        <p class="mb-0">
          <strong class="field">{{ $t('Criticidade') }}:</strong>
          {{ getCriticalityLevel() }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0 px-5" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Aquisição') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Fornecedor') }}:</strong>
          {{
            currentEquipment.supplier != null
              ? currentEquipment.supplier.name
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Valor compra') }}:</strong>
          {{
            currentEquipment.purchasePrice &&
            currentEquipment.purchasePrice != 0
              ? ` ${currentEquipment.purchasePrice.toInstLocale()} `
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Câmbio do dia') }}:</strong>
          {{
            currentEquipment.exchangeDay && currentEquipment.exchangeDay != 0
              ? ` ${currentEquipment.exchangeDay.toInstLocale()}`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Situação') }}:</strong>
          {{ situations[currentEquipment.equipmentAcquisitionSituation] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Data compra') }}:</strong>
          {{
            currentEquipment.purchaseDate != null
              ? formatDate(currentEquipment.purchaseDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="4" md="4" lg="4">
        <p>
          <strong class="field">{{ $t('Data entrega') }}:</strong>
          {{
            currentEquipment.deliveryDate != null
              ? formatDate(currentEquipment.deliveryDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Tempo garantia') }}:</strong>
          {{
            currentEquipment.warrantyTime != null
              ? `${currentEquipment.warrantyTime} meses`
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Início garantia') }}:</strong>
          {{
            currentEquipment.warrantyStartDate != null
              ? formatDate(currentEquipment.warrantyStartDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">{{ $t('Término garantia') }}:</strong>
          {{
            currentEquipment.warrantyEndDate != null
              ? formatDate(currentEquipment.warrantyEndDate)
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3" md="3" lg="3">
        <p class="mb-0">
          <strong class="field">Nota fiscal:</strong>
          {{
            currentEquipment.invoice != ''
              ? currentEquipment.invoice
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="ma-0 px-5" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Depreciação') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Estado de conservação') }}:</strong>
          {{ conservationStates[currentEquipment.conservationState] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Fator fim de vida') }}:</strong>
          {{
            currentEquipment.endLifeFactor != null
              ? endLifeFactors[currentEquipment.endLifeFactor]
              : 'ATUAL'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Fator tecnologia') }}:</strong>
          {{ technologyFactors[currentEquipment.technologyFactor] }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Valor de mercado') }}:</strong>
          {{
            currentEquipment.marketValue
              ? currentEquipment.marketValue.toInstLocale()
              : '00,00'
          }}
        </p>
      </v-col>

      <v-col class="py-0" cols="12" sm="3">
        <p>
          <strong class="field">{{ $t('Valor Depreciado Contábil') }}:</strong>
          {{ depreciatedValue ? depreciatedValue.toInstLocale() : '00,00' }}
        </p>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>

    <v-row class="px-5 ma-0" dense>
      <v-col class="pt-0" cols="12">
        <h3>{{ $t('Informações complementares') }}</h3>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">{{ $t('Manuais que acompanham') }}:</strong>
          {{
            currentEquipment.manuals != ''
              ? currentEquipment.manuals
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">{{ $t('Acessórios e insumos') }}:</strong>
          {{
            currentEquipment.accessories != ''
              ? currentEquipment.accessories
              : 'Sem registro'
          }}
        </p>
      </v-col>
      <v-col class="py-0" cols="12">
        <p>
          <strong class="field">{{ $t('Observações') }}:</strong>
          {{
            currentEquipment.observation != ''
              ? currentEquipment.observation
              : 'Sem registro'
          }}
        </p>
      </v-col>
    </v-row>

    <!-- <v-tabs background-color="#f5f5f5" v-model="tab" color="secondary">
      <v-tab>{{ $t('O.S.') }}</v-tab>
      <v-tab>{{ $t('Migrações') }}</v-tab>
    </v-tabs> -->

    <!-- <v-tabs-items v-model="tab">
      <v-tab-item> -->

    <v-data-table
      :headers="headersServiceOrder"
      :items="serviceOrders"
      class="main-table row-pointer"
      style="background: rgb(245, 245, 245) !important"
      hide-default-footer
      hide-default-header
      :items-per-page="serviceOrders.length"
      :loading="loading"
      disable-pagination
      mobile-breakpoint
      @click:row="openServiceOrder"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.name`]="{ item }">
        {{ item.name }}
      </template>
      <template #[`item.type`]="{ item }">
        {{ serviceOrderTypes[item.serviceOrderType] }}
      </template>
      <template #[`item.requestDate`]="{ item }">
        {{ formatDateTime(item.dateTimeRequest) }}
      </template>
      <template #[`item.closeDate`]="{ item }">
        {{
          item.closeServiceOrderDateTime != null
            ? formatDateTime(item.closeServiceOrderDateTime)
            : 'Sem registro'
        }}
      </template>
    </v-data-table>

    <!-- </v-tab-item>
      <v-tab-item>
        <v-data-table
          :headers="migrationHeaders"
          :items="migrations"
          class="main-table row-pointer"
          hide-default-footer
          hide-default-header
          style="background: rgb(245, 245, 245) !important"
          :items-per-page="migrations.length"
          :loading="loading"
          disable-pagination
        >
          <template #header="{ props, on }">
            <thead>
              <tr>
                <th
                  class="text-center"
                  v-for="header in props.headers"
                  :key="header.value"
                >
                  <v-simple-checkbox
                    v-if="header.value === 'data-table-select'"
                    v-model="props.everyItem"
                    :indeterminate="props.someItems && !props.everyItem"
                    color="purple"
                    @input="on['toggle-select-all']"
                  ></v-simple-checkbox>

                  <div>
                    <v-hover v-slot="{ hover }">
                      <div>
                        <span>{{ $t(header.text) }}</span>
                        <v-icon
                          v-if="
                            hover &&
                            header.value != 'data-table-select' &&
                            header.value != 'actions'
                          "
                          color="white"
                          class="mx-2"
                          @click="on.sort(header.value)"
                        >
                          {{
                            props.options.sortBy.includes(header.value)
                              ? `mdi-chevron-down`
                              : `mdi-chevron-up`
                          }}
                        </v-icon>
                      </div>
                    </v-hover>
                  </div>
                </th>
              </tr>
            </thead>
          </template>

          <template #[`item.name`]="{ item }">
            {{ item.name }}
          </template>
          <template #[`item.type`]="{ item }">
            {{ serviceOrderTypes[item.serviceOrderType] }}
          </template>
          <template #[`item.requestDate`]="{ item }">
            {{ formatDateTime(item.dateTimeRequest) }}
          </template>
          <template #[`item.closeDate`]="{ item }">
            {{
              item.closeServiceOrderDateTime != null
                ? formatDateTime(item.closeServiceOrderDateTime)
                : 'Sem registro'
            }}
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items> -->

    <v-divider class="my-4"></v-divider>

    <v-row class="px-5 text-center" v-if="!currentUser">
      <v-col class="py-0" cols="12">
        <h4 class="mb-5">
          Para abrir um chamado para esse equipamento é preciso entrar no
          sistema
        </h4>
        <v-btn color="#0F3565" @click="callAuth"> Entrar </v-btn>
      </v-col>
    </v-row>
    <v-row class="px-5 text-center" v-else>
      <v-col cols="12" offset-lg="3" sm="6" md="6" lg="6">
        <h4 class="my-5">Abrir chamado para equipamento</h4>
        <v-text-field
          hide-details="auto"
          label="Reclamação/Solicitação"
          v-model="request"
        ></v-text-field>
        <v-btn class="mt-4" color="#0F3565" @click="createCalled">
          Abrir chamado
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
#header {
  display: flex;
  justify-content: space-between;
}
.field {
  display: block;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import Utils from '../../../../Utils/FormatDate'
import moment from 'moment'
import utils from '../../../../Utils/FormatDate'

export default {
  props: {
    equipmentId: String,
  },

  async created() {
    this.currentUser = JSON.parse(localStorage.getItem('user'))

    if (this.currentUser == null) {
      await this.getEquipment(this.equipmentId)
      localStorage.setItem('equipmentIdQrCode', this.equipmentId)
      localStorage.setItem(
        'equipmentInstitutionId',
        this.currentEquipment.institutionId
      )
      this.$toast('Faça login para continuar')
      this.$router.push('/auth')
      return
    }

    await this.getEquipment(this.equipmentId)
    await this.getMtbf()
    await this.listServicesOrders()
    await this.getMigrations()
  },

  data: () => ({
    serviceOrderTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
      'Serviço Administrativo',
      'Empréstimo',
    ],
    endLifeFactors: ['End of life', 'End of service'],
    headersServiceOrder: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Num. OS',
        align: 'center',
        value: 'number',
        sortable: false,
      },
      {
        text: 'Nome',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Tipo',
        align: 'center',

        value: 'type',
      },
      {
        text: 'Data Agendamento',
        align: 'center',

        value: 'requestDate',
      },
      {
        text: 'Data Fechamento',
        align: 'center',

        value: 'closeDate',
      },
    ],

    tab: 0,
    migrations: [],
    technologyFactors: ['Atual', 'Defasagem Mínima', 'Defasado'],
    conservationStates: ['Bom', 'Ruim', 'Péssimo'],
    serviceOrders: [],
    migrationHeaders: [
      {
        text: 'Unidade/Setor Origem',
        align: 'center',
        value: 'departmentSourceName',
        sortable: false,
      },
      {
        text: 'Unidade/Setor Destino',
        align: 'center',
        value: 'departmentDestinyName',
        sortable: false,
      },
      {
        text: 'Data da migração',
        align: 'center',
        value: 'dateFormated',
        sortable: false,
      },
    ],
    mtbf: 0,
    request: null,
    chamadoDialog: false,
    dialogKey: false,
    currentUser: {},
    currentEquipment: {},
    loading: false,
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
    ],
    voltages: [
      '110V',
      '220V',
      '110V / 220V - Bivolt',
      '220V Trifásico',
      '380V Trifásico',
      '440V',
      '480V',
      '13,8KV',
    ],
    functionsEquipment: [
      'Acessório',
      'Análise',
      'Diagnóstico',
      'Outros equipamentos de apoio',
      'Suporte à vida',
      'Terapia',
    ],
    equipmentRisks: [
      'Acessório',
      'Injuria',
      'Morte',
      'Sem risco',
      'Terapia ou diagnóstico inapropriado',
    ],
    apiService: new ApiService(),
  }),

  computed: {
    depreciatedValue() {
      const date = this.currentEquipment.purchaseDate
        ? this.currentEquipment.purchaseDate
        : this.currentEquipment.create

      const years = moment(new Date()).diff(new Date(date), 'years', true)

      const tax = this.currentEquipment.lifeExpectancy
        ? 100 / this.currentEquipment.lifeExpectancy
        : 1

      const amountTax = tax * parseInt(years)

      const value = this.currentEquipment.purchasePrice
        ? this.currentEquipment.purchasePrice
        : this.currentEquipment.marketValue

      return (amountTax / 100) * value
    },
  },

  methods: {
    formatDateTime(date) {
      return utils.dateTime(date)
    },

    async listServicesOrders() {
      await this.apiService
        .get(`serviceOrder/list/all/${this.currentEquipment.id}`)
        .then((response) => {
          this.serviceOrders = response.content
          this.showSchedule = response.content.length > 0
        })
    },

    openServiceOrder(serviceOrder) {
      const route = this.$router.resolve({
        path: `/editServiceOrder/${serviceOrder.id}`,
      })
      window.open(route.href, '_blank')
    },

    async getMigrations() {
      await this.apiService
        .get(`equipment/getMigrations/${this.currentEquipment.id}`)
        .then((response) => {
          this.migrations = response.content.map((value) => {
            return {
              ...value,
              dateFormated: moment(value.migretionDate).format('DD/MM/YYYY'),
            }
          })
        })
    },

    async getMtbf() {
      await this.apiService
        .get(`equipment/mtbf/${this.currentEquipment.id}`)
        .then((response) => {
          this.mtbf = response.content
        })
    },

    getCriticalityLevel() {
      if (
        this.currentEquipment.criticality >= 3 &&
        this.currentEquipment.criticality < 12
      ) {
        return 'Baixa'
      } else if (
        this.currentEquipment.criticality >= 12 &&
        this.currentEquipment.criticality < 19
      ) {
        return 'Média'
      } else if (this.currentEquipment.criticality >= 19) {
        return 'Alta'
      }
    },

    createCalled() {
      localStorage.setItem(
        'equipmentId',
        JSON.stringify({
          id: this.currentEquipment.id,
          identification: this.currentEquipment.identification,
          request: this.request,
        })
      )
      this.$router.push('/newCalled')
    },

    close() {
      this.$emit('close')
    },

    async getEquipment(equipmentId) {
      await this.apiService
        .get(`equipment/getQrCode/${equipmentId}`)
        .then((response) => {
          this.currentEquipment = response.content
        })
    },

    async generatePDF() {
      this.printDialog = true
      this.apiService
        .get(`equipment/printEquipment/${this.currentEquipment.id}`)
        .then((response) => {
          var pdfResult = 'data:application/pdf;base64,' + response.content.pdf
          const link = document.createElement('a')
          link.href = pdfResult
          link.setAttribute(
            'download',
            `Equipamento:${this.currentEquipment.id}_${this.formatDate(
              new Date()
            )}`
          )
          document.body.appendChild(link)
          link.click()
          this.printDialog = false
        })
        .catch((err) => {})
    },

    callAuth() {
      localStorage.setItem(
        'equipmentId',
        JSON.stringify({
          id: this.currentEquipment.id,
          identification: this.currentEquipment.identification,
          request: this.request,
        })
      )

      this.$router.push({
        name: 'LoginClient',
        params: { equipmentId: this.equipmentId },
      })
    },

    formatDate(date) {
      return Utils.moment(date)
    },
  },
}
</script>
